<template>
  <v-container fluid class="pa-0 ma-0">
    <!-- MANAGED SERVICES -->
    <pageHeader> MANAGED SERVICES </pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white"
      >Consistent, Reliable, Resilient.</UnderLinedHeader
    >
    <v-row justify="center" align="center" class="px-12">
      <p class="artice-text text-center">
        The systems that power your business, can experience the occasional
        hiccup. However, those interruptions should not get in the way of
        serving your clients.
      </p>
      <p class="artice-text text-center px-6">
        When frequent technology challenges derail your staff from performing
        daily tasks it impacts the bottom line, morale and your reputation. All
        reasons why we recommend an ongoing Managed Services program, designed
        to maintain uptime and provide emergency support when issues arise.
      </p>
    </v-row>
    <!-- Why Move to Managed Services? -->
    <v-row class="greyBG pt-16 px-16" justify="center">
      <UnderLinedHeader class="pb-8"> Why Move to Managed Services? </UnderLinedHeader>
      <p class="artice-text text-center">
        The popularity of Managed Service plans has increased drastically within
        the past ten years. Due largely in part to cloud-based software adoption
        and the need for consistent connectivity for in-house and remote
        employees. With an added benefit of fixing the cost of IT support,
        moving away from the traditional hourly billing model. In which, IT
        providers were incentivized to wait until an emergency because they
        could bill at a higher hourly rate.
      </p>
      <p class="artice-text text-center px-6">
        We believe that your IT provider is a partner to your business, one that
        should be pro-active and look to avoid issues before they become crises.
        Our comprehensive managed service programs include comprehensive
        monitoring and support for optimal, uninterrupted performance.
      </p>
    </v-row>

    <!-- West Mermis PLLC -->
    <CaseStudy
      :text="item.text"
      :link="item.link"
      :color="item.color"
      :caseStudyText="item.caseStudyText"
      :say="item.say"
      :dashedSay="item.dashedSay"
      v-for="(item, index) in articles"
      :key="index"
      :class="item.class"
    >
      <template v-slot:header>
        <underLinedHeader class="pt-0 pb-6" :class="item.color">
          {{ item.title }}</underLinedHeader
        >
      </template>
      <template v-slot:image>
        <v-img
          contain
          :height="imgSize"
          :src="require('@/assets/imgs/Services/' + item.imgName)"
          :lazy-src="require('@/assets/imgs/Services/' + item.imgName)"
        >
        </v-img>
      </template>
    </CaseStudy>
  </v-container>
</template>



<script>
import CaseStudy from "@/components/global/compnentsMixins/CaseStudy.vue";
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import ImgesMixin from "@/components/global/mixins/ImgesMixin.js";
export default {
  components: { PageHeader, UnderLinedHeader, CaseStudy },
  mixins: [ImgesMixin],
  data() {
    return {
      articles: [
        {
          title: "West Mermis PLLC",
          text: `Compromised IT security can be devastating for smaller law firms.
            For one of our award-winning clients, we quickly migrated their
            document management system to the cloud after experiencing an
            incident where all their server-based confidential files and docs
            were vulnerable to theft. Now, they have come to depend on us for
            all their IT support needs and recognize why it’s important to work
            with legal technology specialists. With our technology expertise,
            we’re helping this smaller firm continue to win awards as well as
            new clients from larger competitors.`,
          imgName: "West-Mermis-Case-Study-600px.png",
          link: "https://f.hubspotusercontent00.net/hubfs/5825854/Client%20Success%20Stories/3545_West%20Mermis_Case%20Study%20FINAL%20ST%20Aug.%2026.pdf",
          caseStudyText: `Read the West Mermis PLLC Case Study and learn more about how our
              team can solve for the unknown in nearly any
              situation.`,
          say: `“3545 demonstrated that not only are they responsive, but they are
          experts. They have people who can address more than just basic IT
          issues but the in-depth challenges. Under the managed service program
          offered by 3545, I don’t have to deal with all the IT issues. It’s
          been definitely less headache for me.”`,
          dashedSay: `— Missy Lonergan, West Mermis PLLC`,
          class: "",
          color: "white",
        },
        {
          title: "Plavnicky Kinzel Makowski LLP",
          text: "",
          imgName: "PKM-Case-Study-600px.png",
          link: "https://secureservercdn.net/45.40.152.13/l8e.e3d.myftpupload.com/wp-content/uploads/case_studies/Case_Study-Plavnicky.pdf",
          caseStudyText:
            "Read the Plavnicky Kinzel Makowski LLP Case Study and learn more about how our team can solve for the unknown in nearly any situation. are serviced by HubSpot.",
          say: `“By engaging 3545 Consulting not just for one-time projects but for ongoing support as the firm’s managed service provider PKM’s staff can focus on tending to clients not troubleshooting issues.”`,
          dashedSay: `— Elizabeth Joliet-Nimmons,
                    Plavnicky Kinzel Makowski LLP`,
          class: "greyBG",
          color: "#f8f9f9",
        },
      ],
    };
  },
  
};
</script>

<style lang="scss" scoped>
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
}
.greyBG {
  background-color: $pgrey !important;
}

</style>